export default __webpack_public_path__ + "static/media/vehicle-profile-vehicle.9fd29d1f.png";